import React, { useState } from 'react';
import {
  CognitoIdentityProviderClient,
  SignUpCommand,
  ConfirmSignUpCommand,
} from '@aws-sdk/client-cognito-identity-provider';

const REGION = 'us-west-2';
const USER_POOL_CLIENT_ID = '3bh5kvk0a93asjbakn19tgjcms';

const cognitoIdpClient = new CognitoIdentityProviderClient({ region: REGION });

export default function SignUp({ onSuccess, onError }) {
  const [step, setStep] = useState('signup');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [preferredUsername, setPreferredUsername] = useState('');
  const [givenName, setGivenName] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const signUp = async () => {
    setLoading(true);
    try {
      const command = new SignUpCommand({
        ClientId: USER_POOL_CLIENT_ID,
        Username: username,
        Password: password,
        UserAttributes: [
          { Name: 'preferred_username', Value: preferredUsername },
          { Name: 'email', Value: email },
          { Name: 'given_name', Value: givenName },
          { Name: 'family_name', Value: familyName },
        ],
      });

      await cognitoIdpClient.send(command);
      setStep('confirm');
    } catch (err) {
      console.error('Sign-up error:', err);
      onError?.('Sign-up failed: ' + (err?.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  const confirmSignUp = async () => {
    setLoading(true);
    try {
      const command = new ConfirmSignUpCommand({
        ClientId: USER_POOL_CLIENT_ID,
        Username: username,
        ConfirmationCode: code,
      });

      await cognitoIdpClient.send(command);
      onSuccess?.();
    } catch (err) {
      console.error('Confirmation error:', err);
      onError?.('Confirmation failed: ' + (err?.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-form">
      {step === 'signup' ? (
        <>
          <h2>Sign Up</h2>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={loading}
          />
          <input
            type="text"
            placeholder="Preferred Username"
            value={preferredUsername}
            onChange={(e) => setPreferredUsername(e.target.value)}
            disabled={loading}
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          <input
            type="text"
            placeholder="First Name"
            value={givenName}
            onChange={(e) => setGivenName(e.target.value)}
            disabled={loading}
          />
          <input
            type="text"
            placeholder="Last Name"
            value={familyName}
            onChange={(e) => setFamilyName(e.target.value)}
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          <button
            onClick={signUp}
            disabled={
              loading ||
              !username ||
              !preferredUsername ||
              !password ||
              !email ||
              !givenName ||
              !familyName
            }
          >
            {loading ? 'Signing up...' : 'Sign Up'}
          </button>
        </>
      ) : (
        <>
          <h2>Confirm Sign Up</h2>
          <input
            type="text"
            placeholder="Confirmation Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            disabled={loading}
          />
          <button onClick={confirmSignUp} disabled={loading || !code}>
            {loading ? 'Confirming...' : 'Confirm'}
          </button>
        </>
      )}
    </div>
  );
}
